import { CANCELORDER_SUBMIT, CANCELORDER_SUBMIT_ERROR, CANCELORDER_SUBMIT_SUCCESS } from './constants';

import { Submit } from 'libs/GrebbCommerceAPI/CancelOrder';
import { getState } from 'state';

export const submit = data => async dispatch => {
    // Attach the current locale so the API can route the subscriber to the
    // correct language-specific Rule segment (the API normalizes e.g. sv_se -> sv).
    if (!data.language) {
        const application = getState('application');
        if (application?.locale) {
            data.language = application.locale;
        }
    }

    dispatch({ type: CANCELORDER_SUBMIT });

    try {
        const response = await Submit(data);

        if (response && !response.error) {
            dispatch({ type: CANCELORDER_SUBMIT_SUCCESS });
            return response;
        }

        throw response?.error instanceof Error
            ? response.error
            : new Error((typeof response?.error === 'string' && response.error) || response?.error?.message || 'Cancel order submission failed');
    } catch (e) {
        dispatch({ type: CANCELORDER_SUBMIT_ERROR });
        throw e;
    }
};
